var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconGuardrail = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4 5.40883L12.2539 3L20.5 5.40883V10.3488C20.5 15.541 17.1772 20.1506 12.2512 21.7919C7.32388 20.1506 4 15.54 4 10.3465V5.40883Z",
  stroke: "#696969",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.18 7.992C13.049 7.992 13.786 8.223 14.38 8.685C14.974 9.147 15.326 9.774 15.436 10.555H14.567C14.457 9.983 14.171 9.543 13.731 9.235C13.302 8.938 12.785 8.795 12.169 8.795C11.256 8.795 10.552 9.114 10.057 9.752C9.595 10.346 9.364 11.127 9.364 12.106C9.364 13.085 9.584 13.866 10.046 14.438C10.53 15.043 11.223 15.351 12.147 15.351C12.774 15.351 13.302 15.186 13.742 14.856C14.204 14.504 14.523 13.987 14.677 13.305H15.546C15.37 14.218 14.963 14.933 14.314 15.439C13.709 15.912 12.983 16.154 12.147 16.154C10.926 16.154 9.991 15.747 9.342 14.944C8.748 14.218 8.462 13.272 8.462 12.106C8.462 10.94 8.759 9.983 9.364 9.235C10.024 8.399 10.97 7.992 12.18 7.992Z",
  fill: "#696969"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconGuardrail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-guardrail.36a166dc2c27f19ff683129d4b339266.svg";